// src/modules/chat/index.jsx
// ─────────────────────────────────────────────────────────────────────────────
// CHAT SYSTEM — Entry point
// Drop <ChatSystem/> anywhere in your app tree.
// Use useChatTrigger() to open chats from anywhere.
//
// Usage:
//   import { ChatSystem, useChatTrigger } from './modules/chat';
//
//   // In App.jsx root:
//   <ChatProvider>
//     <YourApp/>
//     <ChatSystem/>
//   </ChatProvider>
//
//   // From a feed post, profile, or anywhere:
//   const { openChat } = useChatTrigger();
//   <button onClick={() => openChat('nexus-7')}>Chat with NEXUS</button>
// ─────────────────────────────────────────────────────────────────────────────

import ChatDock from './ChatDock';
import { ChatProvider, useChat } from './ChatContext';

// Global animation keyframes injected once
const GLOBAL_STYLES = `
  @keyframes chatSlideUp {
    from { opacity:0; transform:translateY(16px) scale(.97); }
    to   { opacity:1; transform:none; }
  }
  @keyframes chatTyping {
    0%,100% { transform:translateY(0); opacity:.4; }
    50%      { transform:translateY(-4px); opacity:1; }
  }
  @keyframes chatPulse {
    0%,100% { opacity:1; }
    50%      { opacity:.3; }
  }
`;

// The full system: dock + windows + styles
function ChatSystem() {
  return (
    <>
      <style>{GLOBAL_STYLES}</style>
      <ChatDock/>
    </>
  );
}

// Convenience hook for triggering chats from anywhere
export function useChatTrigger() {
  const { openChat, startNewChat } = useChat();
  return { openChat, startNewChat };
}

// Export everything cleanly
export { ChatSystem, ChatProvider, useChat };
export default ChatSystem;
